import { Box, BoxProps, Link, Stack, StackProps, styled } from '@mui/material'
import { ComponentProps, ComponentType } from 'react'

export const StyledForm: ComponentType<ComponentProps<'form'>> = styled( 'form' )( ( { theme } ) => ( {
	maxWidth: theme.spacing( 75 ),
	marginTop: theme.spacing( 2 ),
	marginBottom: theme.spacing( 7 ),
} ) )

export const FooterContainer: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	backgroundColor: theme.palette.background.paper,
	borderTop: `1px solid ${theme.palette.grey[ 300 ]}`,
	bottom: 0,
	display: 'flex',
	justifyContent: 'space-between',
	left: 0,
	padding: theme.spacing( 2 ),
	paddingLeft: theme.spacing( 7 ),
	paddingRight: theme.spacing( 7 ),
	position: 'fixed',
	right: 0,
	zIndex: 1000,
	width: `calc(100vw - ${theme.spacing( 14 )})`,
} ) )

export const FooterButtonContainer: ComponentType<ComponentProps<typeof Box>> = styled( Box )( ( ) => ( {
	flex: 1,
	display: 'flex',
	justifyContent: 'space-between',
} ) )

export const BackLink: ComponentType<ComponentProps<typeof Link>> = styled( Link )( ( { theme } ) => ( {
	'textDecoration': 'none',
	'display': 'flex',
	'alignItems': 'center',
	'color': theme.palette.primary.main,
	'&:hover': {
		textDecoration: 'underline',
	},
} ) )

export const FormInputSection: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	paddingBottom: theme.spacing( 2 ),
} ) )

export const FeedDescriptionSection: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	marginBottom: theme.spacing( 3 ),
} ) )
